import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import '../../../components_style/doctorComponents/FormsStyle.css'
import FormElementContainer from "../../../components/forms_builder/FormElementContainer";
import PatientDetails from "../../../components/PatientOnboard/PatientDetails";
import ContactDetails from "../../../components/PatientOnboard/ContactDetails";
import Physiological_biometrics from "../../../components/PatientOnboard/Physiological_biometrics";
import Lifestyle from "../../../components/PatientOnboard/Lifestyle";
import * as Yup from "yup";
import FormElementContainerExpanded from "../../../components/forms_builder/FormElementContainerExpanded";
import FormElementContainerNotExpanded from "../../../components/forms_builder/FormElementContainerNotExpanded";


const validationSchema = Yup.object().shape({

    ID_passport:Yup.string().required('This field is mandatory').matches(/^\d+$/, 'The field should have digits only').test('len', 'Must be exactly 9 characters', val => val.length === 9),
    House_number:Yup.string().matches(/^\d*$/, 'The field should have digits only').nullable(),
    Phone_num2:Yup.string().matches(/^\d*$/, 'The field should have digits only').nullable(),
    Systolic_blood_press_mmHg:Yup.string().matches(/^\d*$/, 'The field should have digits only').nullable(),
    Diastolic_blood_press_mmHg:Yup.string().matches(/^\d*$/, 'The field should have digits only').nullable(),
    Email:Yup.string().matches( /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,'Mail is invalid').nullable(),
    First_name:Yup.string().required('This field is mandatory'),
    Last_name:Yup.string().required('This field is mandatory'),
/*
    receiving_asaya_system_assisted:Yup.string().required('This field is mandatory').nullable(),
*/

    receiving_asaya_system_assisted:Yup.string().matches("Yes", 'Patient should sign Terms'),


    Phone_num1:Yup.string().nullable().required('This field is mandatory').matches(/^\d+$/, 'The field should have digits only'),
    /*
        Gender:Yup.string().nullable().required('This field is mandatory'),
    */
/*
    Insuring_factor:Yup.string().nullable().required('This field is mandatory'),
*/
/*    Driving:Yup.string().nullable().required('This field is mandatory'),
    Pregnant: Yup.string().when("Gender", {
        is: value => {
            return value === "Female"
        },
        then: Yup.string().required('This field is mandatory'),
        otherwise: Yup.string().nullable()
    }),
    Breast_feeding: Yup.string().when("Gender", {
        is: value => {
            return value === "Female"
        },
        then: Yup.string().nullable().required('This field is mandatory'),
        otherwise: Yup.string().nullable()
    }),
    Commercial_license: Yup.string().when("Driving", {
        is: value => {
            return value === "Yes"
        },
        then: Yup.string().nullable().required('This field is mandatory'),
        otherwise: Yup.string().nullable()
    }),*/
})

class PersonalDetailsTabComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            view: 1,
            errors:this.props.errors
        };
    }
    componentWillMount() {
        this.props.initValidation(validationSchema)
    }
    onValueChange = (name,value) => {
        this.props.onValueChange(name,value)
    }

    onYesNoValueChange = (name,value) => {
        this.props.onYesNoValueChange(name,value)
    }

    onclickSetProfilePic = (value) => {
        this.props.onclickSetProfilePic(value)
    }



    render() {
        let {t} = this.props

        return (
            <>
                    <FormElementContainerExpanded title={t('patient_boarding.personal_details')}
                                              Component={PatientDetails}
                                              rest={{
                                                  onValueChange:(name,value) => this.onValueChange(name,value) ,
                                                  onclickSetProfilePic:(value) => this.onclickSetProfilePic(value) ,
                                                  profilePic:this.props.profilePic,
                                                  allHCPs:this.props.allHCPs,
                                                  entry:this.props.entry,
                                                  errors:this.props.errors,
                                                  t:(e) => this.props.t(e),
                                                  onYesNoValueChange:(name, value) => this.onYesNoValueChange(name, value)
                                              }}/>

                    <FormElementContainerExpanded title={t('patient_boarding.ContactDetails')}
                                          Component={ContactDetails}
                                          rest={{
                                              onValueChange:(name,value) => this.onValueChange(name,value) ,
                                              onYesNoValueChange:(name, value) => this.onYesNoValueChange(name, value),
                                              entry:this.props.entry,
                                              israelCities:this.props.israelCities,
                                              t:(e) => this.props.t(e),
                                              errors:this.props.errors,
                                          }}/>


                    <FormElementContainerExpanded title={t('patient_boarding.Lifestyle')}
                                          Component={Lifestyle}
                                          rest={{
                                              onValueChange:(name,value) => this.onValueChange(name,value) ,
                                              onYesNoValueChange:(name, value) => this.onYesNoValueChange(name, value),
                                              entry:this.props.entry,
                                              errors:this.props.errors,
                                              t:(e) => this.props.t(e),
                                          }}/>

                   <FormElementContainerNotExpanded title={t('patient_boarding.Physiological_Biometrics')}
                                         Component={Physiological_biometrics}
                                         rest={{
                                             onValueChange:(name,value) => this.onValueChange(name,value) ,
                                             entry:this.props.entry,
                                             t:(e) => this.props.t(e),
                                             errors:this.props.errors
                                         }}/>


                    <div className={'blankSpace'}/>
{/*
                </div>
*/}
            </>
        );
    }
}



const PersonalDetailsTab = compose(
    withTranslation(),
    /*connect(
        mapStateToProps,
        mapDispatchToProps
    )*/
)(PersonalDetailsTabComposed);

export default PersonalDetailsTab;
